"use client";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import * as React from "react";

import { COMMON_COPY } from "copy/common";
import { useCopy } from "i18n/useCopy";

import { cn } from "../../../../../products/muggleTestV0/lib/utils";

const ModalCloseButton = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Close>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Close>
>(({ className, ...props }, ref) => {
  const copy = useCopy();

  return (
    <DialogPrimitive.Close
      ref={ref}
      className={cn(
        "absolute right-4 top-4 z-20 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
        // A finger-sized target on a phone; the negative margin keeps the icon where it sits.
        "max-sm:-m-3.5 max-sm:p-3.5",
        className
      )}
      {...props}
    >
      <X className="h-4 w-4" />
      <span className="sr-only">{copy.text(COMMON_COPY.actions.close)}</span>
    </DialogPrimitive.Close>
  );
});
ModalCloseButton.displayName = "ModalCloseButton";

export { ModalCloseButton };
